import { Button } from '@chakra-ui/button';
import { Box, VStack } from '@chakra-ui/layout';
import { Flex, IconButton, ModalBody, ModalContent, ModalFooter, ModalHeader } from '@chakra-ui/react';
import { Icon } from '@common/components/Icon';
import { Image } from '@common/components/Image';

import React from 'react';
import { TextBlock } from 'src/apps/invest/common/components/TextBlock';
import { useSurveyBannerModel } from '../models/SurveyBannerModel';

export const SetupComplete: React.FC = () => {
  const model = useSurveyBannerModel();

  return (
    <ModalContent>
      <ModalHeader
        display={'flex'}
        alignItems={'center'}
        justifyContent={'space-between'}
        borderBottomWidth={'1px'}
        borderBottomColor={'gray.300'}>
        <IconButton
          color="black"
          variant={'ghost'}
          aria-label="Back"
          icon={<Icon icon="chevron-left" />}
          onClick={() => model.prevStep()}
        />
        Done
        <IconButton
          color="black"
          variant={'ghost'}
          aria-label="Back"
          icon={<Icon icon="times" />}
          onClick={() => {
            window.location.reload();
          }}
        />
      </ModalHeader>
      <ModalBody>
        <Flex py="24px" flex={1} justifyContent={'space-between'} flexDirection={'column'} display={'flex'}>
          <VStack>
            <Image image="celebration" width={120} />
            <Box mt="10px">
              <TextBlock textAlign={'left'} weight="bold" fontSize={'18px'} lineHeight={'18px'}>
                You're all set!
              </TextBlock>
            </Box>
            <TextBlock maxW={'xs'} textAlign={'center'}>
              Your account set up is complete. You’re ready to make your first investment!
            </TextBlock>
          </VStack>
        </Flex>
      </ModalBody>
      <ModalFooter>
        <Button
          w={'100%'}
          mt={'10px'}
          onClick={() => {
            window.location.reload();
          }}>
          Close
        </Button>
      </ModalFooter>
    </ModalContent>
  );
};
